module.exports = __webpack_public_path__ + "img/completed-check-mark-chl.7fbb369b.svg";